import { useMutation, useQuery, useQueryClient } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  CreateSupplierAddressRequest,
  UpdateSupplierAddressRequest,
} from './SupplierAddress.types';

import {
  listSupplierAddresss,
  createSupplierAddress,
  updateSupplierAddress,
  deleteSupplierAddress,
  getSupplierMainAddress,
} from './SupplierAddress.service';
import { notification } from 'antd';
import { useIntl } from 'react-intl';

export function useSupplierAddresses(supplierId?: number) {
  const query = useQuery(
    ['supplier', supplierId, 'address'],
    () => (supplierId ? listSupplierAddresss(supplierId) : null),
    { enabled: !!supplierId },
  );

  useServiceError(query.error);

  return query;
}

export function useCreateSupplierAddress(supplierId: number) {
  const intl = useIntl();
  const mutation = useMutation(
    (obj: CreateSupplierAddressRequest) =>
      createSupplierAddress(supplierId, obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'suppliers.address.create.notification.success',
          }),
          description: intl.formatMessage({
            id: 'suppliers.address.create.notification.successDescription',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateSupplierAddress(supplierId: number) {
  const intl = useIntl();
  const mutation = useMutation(
    (obj: UpdateSupplierAddressRequest) =>
      updateSupplierAddress(supplierId, obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'suppliers.address.update.notification.success',
          }),
          description: intl.formatMessage({
            id: 'suppliers.address.update.notification.successDescription',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteSupplierAddress(supplierId: number) {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const mutation = useMutation(() => deleteSupplierAddress(supplierId), {
    onSuccess() {
      queryClient.removeQueries(['supplier', supplierId, 'address']);
      notification.success({
        message: intl.formatMessage({
          id: 'suppliers.address.remove.notification.success',
        }),
        description: intl.formatMessage({
          id: 'suppliers.address.remove.notification.successDescription',
        }),
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useGetSupplierMainAddress() {
  return useMutation(getSupplierMainAddress);
}
